import type { FC, ReactNode } from 'react';
import { Modal, InlineNotification } from '@carbon/react';
import styles from './promote-modal.module.scss';

interface PromoteModalProps {
  open: boolean;
  workspaceName: string;
  loading: boolean;
  error: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /** Replaces the pre-drill body, for a workspace type with its own consequences to state. */
  children?: ReactNode;
}

// Promote confirmation. Terminal: freezes the workspace and adopts the geometry
// as the well's authoritative pre-drill artifact.
export const PromoteModal: FC<PromoteModalProps> = ({
  open,
  workspaceName,
  loading,
  error,
  onClose,
  onConfirm,
  children,
}) => (
  <Modal
    open={open}
    modalHeading="Promote workspace"
    primaryButtonText={loading ? 'Promoting…' : 'Promote'}
    secondaryButtonText="Cancel"
    primaryButtonDisabled={loading}
    onRequestClose={onClose}
    onRequestSubmit={onConfirm}
  >
    {children ?? (
      <p className={styles.body}>
        Promoting <strong>{workspaceName}</strong> freezes this workspace and
        records the verdict on the well. This cannot be undone — create a new
        workspace to redo.
      </p>
    )}
    {error && (
      <InlineNotification
        kind="error"
        lowContrast
        hideCloseButton
        title="Failed to promote"
        className={styles.error}
      />
    )}
  </Modal>
);
